module.exports = __webpack_public_path__ + "img/Unidad13-5.4490ff4d.png";